<section *ngIf="showFundProspectus" class="bfa-component-wrapper prospectus-links">
	<section class="section-separator"></section>
	<h4 class="margin-top-20 margin-bottom-10 text-condensed-14-bold" dcrHTMLKey="FUND_PROSPECTUS_TITLE">FUND PROSPECTUS:</h4>
	<ul class="prospectus-list">
		<li class="text-condensed-14-bold" *ngFor="let fund of fundsToShow; index as i; trackByFields: 'ticker'">
			<a target="_blank" href="{{ baseUrl + fund.cusip }}" [attr.data-link-event]="'Fund Prospectus : ' + fund.ticker | analyticEventEvaluatorPipe">
				{{ fund.ticker }}
			</a>
		</li>
	</ul>
</section>
